module.exports = __webpack_public_path__ + "assets/img/qrcode-xhs-177bdddb.png";